import styled from "styled-components";

export const TagKeyContainer = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
`;